import { Box, Typography } from '@mui/material';
import { EmailOutlined, AccountCircleOutlined } from '@mui/icons-material';
import { ROUTING_CONFIG } from '@uplift/constants';
import { ProviderMedicalRole } from '@uplift/types';
import { ContactInfoRow, Indicator, StackableCard } from '@uplift/ui-v2';
import { Link } from 'react-router-dom';
import { ProviderAvatar } from './provider-card-avatar.component';
import { useStyles } from './provider-card.styles';
import { useL10n } from '@uplift/hooks';
import { ProviderCardViewProps } from './provider-card.component';
import { useProviderPublicMatchingProfile } from '@uplift/queries';

export const ProviderCardDesktop: React.VFC<ProviderCardViewProps> = ({ matchId, providerType, email, userName, provider }) => {
  const l10n = useL10n();
  const { classes } = useStyles();
  const { data: publicProfile } = useProviderPublicMatchingProfile(provider.id, { enabled: !!provider?.id, suspense: true });

  return (
    <StackableCard className={classes.content}>
      <Box className={classes.info}>
        <ProviderAvatar src={publicProfile?.avatarAsset?.url} size={56} />
        <Box className={classes.rightBlock}>
          <Box className={classes.nameLine}>
            <Typography variant="h6" className={classes.fullNameText}>
              {userName}
            </Typography>
            {publicProfile.profile.pronouns && (
              <Typography variant="body1">
                ({publicProfile.profile.pronouns})
              </Typography>
            )}
          </Box>
          <Typography color="textSecondary">
            {l10n.resources.provider.types[providerType]}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.actions}>
        <ContactInfoRow
          icon={EmailOutlined}
          primary={email}
          text={email}
          type="email"
        />

        <ContactInfoRow
          icon={AccountCircleOutlined}
          primary={(
            <Box display="flex" gap=".5rem" pb="1px">
              <Typography variant="body1" component={Link} to={`${ROUTING_CONFIG.careTeam}/${provider.id}`} color="textPrimary">
                {l10n.general.viewProfile}
              </Typography>
              {provider.medicalRole === ProviderMedicalRole.therapist && (
                <>
                  <Box display="flex" alignItems="center" pb="2px">
                    <Indicator color="black" size="sm" />
                  </Box>
                  <Typography variant="body1" component={Link} to={`/rematching/${matchId}`} color="textPrimary">
                    {l10n.requestRematch.findANewTherapist}
                  </Typography>
                </>
              )}
            </Box>
          )}
        />
      </Box>
    </StackableCard>
  );
};
